module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('Toast', {
    staticStyle: {
      "margin-top": "35px"
    }
  }), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.inquiryList,
      "paginator": true,
      "rows": 8,
      "data-key": "id"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Name",
      "field": "name"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Email",
      "field": "email"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Company Name",
      "field": "companyName"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Phone Number",
      "field": "phoneNumber"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Subject",
      "field": "subject"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Message",
      "field": "message"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Remarks",
      "field": "response"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.openRemarksDialog(slotProps.data)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('form', [_c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Update Inquiry",
      "visible": _vm.showDialog,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Inquiry Remarks:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.response),
      expression: "response"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "10",
      "cols": "10"
    },
    domProps: {
      "value": (_vm.response)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.response = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('Button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateInquiry
    }
  }, [_vm._v("\n            Update\n          ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelInquiry
    }
  }, [_vm._v("\n            Cancel\n          ")])], 1)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217e61c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/admin/inquiry.vue
// module id = 2085
// module chunks = 0